import React from 'react';

export const VideoPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs = {}, specificAttrs = {} } = component;
  const { src, controls } = specificAttrs;
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <video
        src={src || 'https://www.w3schools.com/html/mov_bbb.mp4'}
        controls={controls !== false}
        style={{
          width: '100%',
          maxWidth: '100%',
          borderRadius: '8px',
          background: '#000000',
          display: 'block'
        }}
      />
    </div>
  );
};
